import { AppActions, AppTitle, AppTitleText } from '@/components/app-header/app-header';
import { ControlledDatePicker } from '@/components/date-picker';
import { RefreshButton } from '@/components/refresh-button';
import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useIsFilterValid, useProfileActions } from './store/store';
import { ProfilesMetrics } from './components/metrics-header';
import { ProfilesTable } from './components/table';
import { ProfileCsvDownload } from './components/download-button';
import { yearMonthDayToDate } from '@contextual/common';

export function ProfilesPages() {
  const { setDateRange } = useProfileActions();

  const [searchParams] = useSearchParams();
  const fromDate = searchParams.get('from');
  const toDate = searchParams.get('to');

  useEffect(() => {
    if (fromDate && toDate) {
      setDateRange({
        startDate: yearMonthDayToDate(fromDate, 'start'),
        endDate: yearMonthDayToDate(toDate, 'end')
      });
    }
  }, [fromDate, toDate, setDateRange]);

  return (
    <div>
      <AppTitle>
        <AppTitleText>Profiles</AppTitleText>
      </AppTitle>

      <AppActions>
        <ProfilesRefreshButton />
      </AppActions>
      <AppActions>
        <ControlledDatePicker />
      </AppActions>
      <AppActions>
        <ProfileCsvDownload />
      </AppActions>
      <ProfilesPage />
    </div>
  );
}

export function ProfilesPage() {
  const isValid = useIsFilterValid();

  if (!isValid) {
    return null;
  }

  return (
    <div className="grid grid-cols-12 gap-6">
      <div className="col-span-12">
        <ProfilesMetrics />
      </div>
      <div className="col-span-12">
        <ProfilesTable />
      </div>
    </div>
  );
}

// Todo fake loading for now but set the client state
export function ProfilesRefreshButton() {
  const { setLastRefetchDate } = useProfileActions();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  function handleRefreshClick() {
    setIsRefreshing(true);
    setLastRefetchDate(new Date());
    timerRef.current = setTimeout(() => {
      setIsRefreshing(false);
    }, 1000);
  }

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return (
    <RefreshButton
      onClick={() => {
        handleRefreshClick();
      }}
      isRefreshing={isRefreshing}
    />
  );
}
